import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, ListItemText, MenuItem, TextField } from "@mui/material";
import { faAngleDown as farAngleDown } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import React from "react";
import { getNewValueFromSelection } from "./RichTextFieldCustomToolbar";
import { autocompleteSxProps } from "./FontSelection";
const quillFormat = "size";
export const FontSizeSelection = ({ selectOptions, quillRef, className, defaultValue, currentValueRef }) => {
    var _a;
    const textLength = (_a = quillRef === null || quillRef === void 0 ? void 0 : quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor().getLength();
    const value = getNewValueFromSelection({ index: 0, length: textLength - 1 }, quillFormat, quillRef) || (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.toString());
    const [currentValue, setCurrentValue] = React.useState(value.endsWith("px") ? value.slice(0, -2) : value);
    React.useEffect(() => {
        quillRef.current.getEditor().on("selection-change", (range, oldRange, source) => {
            if (source === "user" && quillRef.current && range && currentValue) {
                const newValue = getNewValueFromSelection(range, quillFormat, quillRef) || currentValue;
                // Slice the last two characters ('px')
                const slicedValue = newValue.endsWith("px") ? newValue.slice(0, -2) : newValue;
                setCurrentValue(slicedValue);
                currentValueRef.current = slicedValue;
            }
        });
    }, []);
    const changeHandler = (e, newValue) => {
        if (newValue) {
            const valueToSet = `${newValue}px`;
            quillRef.current.editor.format(quillFormat, valueToSet, "user");
            setCurrentValue(newValue);
            currentValueRef.current = newValue;
        }
    };
    const renderedOptions = () => {
        return (props, option, { selected }) => _jsx(MenuItem, Object.assign({}, props, { dense: true, selected: selected, value: option, children: _jsx(ListItemText, { primary: option, primaryTypographyProps: { whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" } }) }));
    };
    const renderedInput = () => {
        return (params) => _jsx(TextField, Object.assign({}, params, { variant: "standard" }));
    };
    return _jsx(Autocomplete, { size: "small", sx: autocompleteSxProps, className: className, value: currentValue, disableClearable: true, onChange: changeHandler, options: selectOptions, renderInput: renderedInput(), renderOption: renderedOptions(), popupIcon: _jsx(FontAwesomeIcon, { icon: farAngleDown }), noOptionsText: "" });
};
//# sourceMappingURL=FontSizeSelection.js.map